import React, { ReactNode } from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import usePlatform from "../../../../hooks/usePlatform"

interface StyleProps {
  isDesktop: boolean
}
const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      width: ({ isDesktop }) => (isDesktop ? 220 : "100%"),
    },
    title: {
      marginBottom: 8,
      wordBreak: "keep-all",
      fontSize: 18,
      fontWeight: 700,
      color: "rgba(0, 0, 0, .87)",
      [theme.breakpoints.up("md")]: {
        marginBottom: 0,
      },
    },
    description: {
      wordBreak: "keep-all",
      fontSize: 15,
      fontWeight: 500,
      color: "rgba(0, 0, 0, .6)",
    },
    imageWrapper: {
      width: ({ isDesktop }) => (isDesktop ? 32 : 24),
      height: ({ isDesktop }) => (isDesktop ? 32 : 24),
      marginTop: 24,
      marginBottom: 10,
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        marginTop: 0,
      },
    },
  })
)
interface DescriptionProps {
  iconUrl: string
  title: ReactNode
  description: ReactNode
}

export default function SummaryAdvantage({ iconUrl, title, description }: DescriptionProps) {
  const { isDesktop } = usePlatform()
  const classes = useStyles({ isDesktop })

  return (
    <div className={classes.root}>
      <div className={classes.imageWrapper}>
        <img src={iconUrl} />
      </div>
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.description}>{description}</Typography>
    </div>
  )
}
